module.exports = __webpack_public_path__ + "static/media/ic_github_menu.daf23a7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ic_github_menu.svg
// module id = 289
// module chunks = 0